import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const init = () => {
	document.addEventListener('DOMContentLoaded', () => {
		const layers = document.querySelectorAll('.layer');
		const scrollSection = document.querySelector('.scroll-section');
		const leftStickyContent = document.querySelector(
			'.left-sticky-content',
		);
		const leftContent = document.querySelector('.left-content');

		if (!layers.length) return;
		const lastLayer = layers[layers.length - 1];

		// Simple load animation to visually confirm GSAP is working
		gsap.from(layers, {
			y: 30,
			opacity: 0,
			duration: 0.8,
			stagger: 0.15,
			ease: 'power2.out',
			clearProps: 'all', // Clears inline styles after animation so your CSS classes take over!
		});

		// Pin the left column while the right side scrolls
		if (scrollSection && leftStickyContent) {
			let mm = gsap.matchMedia();

			mm.add('(min-width: 2560px)', () => {
				ScrollTrigger.create({
					trigger: leftStickyContent,
					start: () => `top center-=${leftContent.offsetHeight / 2}`,
					endTrigger: lastLayer,
					end: 'top center-=310', // Unpins the exact moment the last layer becomes active
					pin: leftStickyContent,
				});
			});

			mm.add('(min-width: 1920px) and (max-width: 2559px)', () => {
				ScrollTrigger.create({
					trigger: leftStickyContent,
					start: () => `top center-=${leftContent.offsetHeight / 2}`,
					endTrigger: lastLayer,
					end: 'top center-=255', // Unpins the exact moment the last layer becomes active
					pin: leftStickyContent,
				});
			});

			mm.add('(min-width: 1440px) and (max-width: 1919px)', () => {
				ScrollTrigger.create({
					trigger: leftStickyContent,
					start: () => `top center-=${leftContent.offsetHeight / 2}`,
					endTrigger: lastLayer,
					end: 'top center-=210', // Unpins the exact moment the last layer becomes active
					pin: leftStickyContent,
				});
			});

			mm.add('(min-width: 1024px) and (max-width: 1439px)', () => {
				ScrollTrigger.create({
					trigger: leftStickyContent,
					start: () => `top center-=${leftContent.offsetHeight / 2}`,
					endTrigger: lastLayer,
					end: 'top center-=190', // Unpins the exact moment the last layer becomes active
					pin: leftStickyContent,
				});
			});
		}

		// Replace manual scroll math with ScrollTrigger
		layers.forEach((layer, index) => {
			const isLast = index === layers.length - 1;

			ScrollTrigger.create({
				trigger: layer,
				start: 'top center', // Trigger when the top of the element hits the center of the viewport
				end: isLast ? 'bottom top' : 'bottom center', // Keep the last layer active until it scrolls completely off screen
				toggleClass: 'active',
				markers: false, // Uncomment this line if you want to visually see the trigger zones on screen
			});
		});
	});
};

export { init };
